export default () => (
  <path d="M12 3.25c.55 0 1.07.3 1.35.77l8.44 14.38a1.56 1.56 0 0 1-1.35 2.35H3.56a1.57 1.57 0 0 1-1.35-2.35l8.44-14.38c.28-.48.8-.77 1.35-.77Zm0 5a.94.94 0 0 0-.94.94v4.37a.94.94 0 1 0 1.88 0V9.2a.94.94 0 0 0-.94-.94ZM13.25 17a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Z" />
);
